export default __webpack_public_path__ + "static/media/T5WInfographics5.0af395c80add37a76c8cb18a30a5de77.png";